export const STATUS_META = {
  novo: { label: "Novo", className: "bg-slate-100 text-slate-700 border-slate-200" },
  revisao: { label: "Em revisão", className: "bg-amber-50 text-amber-700 border-amber-200" },
  pedidos: { label: "Pedidos", className: "bg-blue-50 text-blue-700 border-blue-200" },
  gerado: { label: "Gerado", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  exportado: { label: "Exportado", className: "bg-violet-50 text-violet-700 border-violet-200" },
};

export function statusMeta(s) {
  return STATUS_META[s] || STATUS_META.novo;
}
